import './reducers/exports';
import './sagas/exports';

export {default as OverviewView} from './pages/overview/OverviewView';
export {default as Settings} from './pages/settings/SettingsView';
//export {default as NewsView} from './pages/news/NewsView';
export {default as Dashboard} from './pages/dashboard/DashboardView';
export {default as SignUp} from './pages/signup/SignUpView';
export {default as Payout} from './pages/payout/PayoutView';
export {default as CmsPage} from './pages/cms-page/CmsPageView';
